import { ecoClientState } from "state/ecoState";
import { useRecoilValue } from "recoil" ;
import { EcoClient } from "@eco/client" ;

/**
 * Get EcoClient from context
 */
const useEcoClient = () => useRecoilValue<EcoClient>(ecoClientState)  ;

export default useEcoClient ;
